// Pathify
import { make } from 'vuex-pathify'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  items: [
    {
      title: '나의 회의',
      icon: 'mdi-clipboard-list-outline',
      to: '/list/',
      isAdmin: false,
    },
    {
      title: '회의실 예약 현황',
      icon: 'mdi-calendar',
      to: '/calendar/',
      isAdmin: false,
    },
    {
      title: '예약 승인 관리',
      icon: 'mdi-format-list-checks',
      to: '/approveMgt/',
      isAdmin: false,
      isViewReserveManagers: true,
    },
    {
      title: '회의실 예약 문의',
      icon: 'mdi-help',
      to: '/help/',
      isAdmin: true,
      key: 'help',
      role: 'admin',
    },
    {
      title: '대시보드',
      icon: 'mdi-view-dashboard',
      to: '/dashboard/',
      isAdmin: true,
      key: 'dashboard',
      role: 'admin',
    },
    {
      title: '통계',
      icon: 'mdi-chart-bar',
      to: '/analytics/',
      isAdmin: true,
      key: 'analytics',
      role: 'admin',
    },
    {
      title: '회의실 관리',
      icon: 'mdi-door-open',
      to: '/manageRoom/',
      isAdmin: true,
      key: 'rooms',
    },
    {
      title: '공지사항 관리',
      icon: 'mdi-comment-alert-outline',
      to: '/manageNotice/',
      isAdmin: true,
      key: 'notice',
    },
    {
      title: '권한 관리',
      icon: 'mdi-account-multiple-check',
      to: '/manageAuth/',
      isAdmin: true,
      key: 'auth',
    },
    {
      title: '시스템 설정',
      icon: 'mdi-cogs',
      to: '/settings/',
      isAdmin: true,
      key: 'settings',
      role: 'admin',
    },
    {
      title: '로그',
      icon: 'mdi-database-arrow-left',
      to: '/logs/',
      isAdmin: true,
      key: 'logs',
    },
  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
